/** Public URL segment: `goalise-337752` → `337752`. */
export function articlePathId(id) {
  const s = String(id ?? "").trim();
  const m = /^goalise-(\d+)$/i.exec(s);
  return m ? m[1] : s;
}

/** Route param → API / DB id (`337752` → `goalise-337752`). */
export function resolveArticleRouteId(param) {
  const p = decodeURIComponent(String(param ?? "")).trim();
  if (/^\d+$/.test(p)) return `goalise-${p}`;
  return p;
}